var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card h-100"},[_vm._m(0),_c('highmaps',{attrs:{"options":_vm.moptions}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header p-4"},[_c('h5',{staticClass:"m-0"},[_vm._v("PRODUCE MAP DISTRIBUTION")])])
}]

export { render, staticRenderFns }